import React from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { CustomButton } from "../../../../components/Button/Button";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useWorklogCsvDownload } from "../hooks/useWorklogCsvDownload";

function Download({ byTask = false }) {
  const { id } = useBoardIdByKey();
  const [searchParams] = useSearchParams();
  const user = searchParams
    .get("search")
    ?.split(",")
    ?.map((user) => ({ user_id: user }))
  // const user = useMemo(
  //   () => groupingUser.map((item) => item?.users).flat(),
  //   [groupingUser]
  // );
  const checkedList = useSelector((state) => state.search.boardSearch);
  const dateRange = useSelector((state) => state.search.dateRange);
  const epicSearch = useSelector((state) => state.search.epicSearch);

  const { downloadCsv } = useWorklogCsvDownload({
    users: user,
    boardIds: checkedList.length > 0 ? checkedList.length : [id],
    dateRange,
    epicSearch,
    byTask,
  });
  return (
    <CustomButton
      variant="contained"
      className="see-worklogs"
      onClick={downloadCsv}>
      Download Worklogs
    </CustomButton>
  );
}

export default Download;
